import React from 'react';
import SidebarTemplate from 'components/templates/SidebarTemplate';
import PrescribedDaysConfigForm from 'components/organismos/master/labor/PrescribedDaysConfigForm';
import { useParams } from 'react-router-dom';
import FormContents from 'components/atoms/Form/FormContents';
import TabControl from 'components/atoms/TabControl';
import PrescribedDaysCreateForm from 'components/organismos/master/labor/PrescribedDaysCreateForm';
import FormHeader from 'components/templates/FormHeader';
import { css } from '@emotion/core';

type SelectTab = 'edit'|'setting';
const SelectTab: {[key in SelectTab]: SelectTab} = {
  edit: 'edit',
  setting: 'setting',
};

const WorkingDaysEditPage: React.FC = () => {
  const {
    // workingDaysId,
    tabIndex,
  } = useParams();

  const [selectTab, setSelectTab] = React.useState<SelectTab>(
    tabIndex === '1' ? SelectTab.setting : SelectTab.edit,
  );

  return (
    <SidebarTemplate>
      <FormHeader title="所定労働日数編集" />
      <FormContents customStyle={css({marginTop:'60px'})}>
        <div style={{paddingLeft: '15px', paddingTop: '15px'}}>
        <TabControl
          items={[
            {
              value: SelectTab.edit,
              display: '所定労働日数',
            },
            {
              value: SelectTab.setting,
              display: '組織割当情報',
            },
          ]}
          setValue={setSelectTab as (arg: string) => void}
          currentValue={selectTab}
          isFixed={true}
          type={1}
        />
        </div>
        {selectTab === SelectTab.edit
        && (
          <PrescribedDaysCreateForm />
        )}
        {selectTab === SelectTab.setting
        && (
          <PrescribedDaysConfigForm />
        )}

      </FormContents>
    </SidebarTemplate>
  );
};
export default WorkingDaysEditPage;
